module.exports = __webpack_public_path__ + "img/shape-home-mobiel.4dd087b68a2b5a3124c4f02e6dd70527.svg";